
import { Component, Vue } from "vue-property-decorator";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import { objAny } from "@/common/common-interface";
import { getInterflowList, auditOprSystem } from "@/api/api-interconnection";
import { getOptionList, optionKey } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-select-oper": piSelectOper
  }
})
export default class PiAuditOprSystem extends Vue {
  private total = 0;
  private formInline: objAny = {
    globalOrder: "",
    globalSearch: "",
    netDriection: "",
    netStatus: "",
    oprPkId: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private netDriectionList: object[] = [];
  private netStatusList: object[] = [];
  private auditForm: objAny = {
    netStatus: 2,
    netSystemPkId: ""
  };
  private auditModal = false;
  private applyStatusList: object[] = [
    { label: i18n.t("auditHlhtSystem.yes"), value: 2 },
    { label: i18n.t("auditHlhtSystem.no"), value: 1 }
  ];
  private loading = false;
  public queryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  private tableColumns: object[] = [
    {
      title: i18n.t("auditHlhtSystem.systemName"),
      key: "systemName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("auditHlhtSystem.systemName"),
      key: "contactName",
      resizable: true,
      minWidth: 90
    },
    {
      title: i18n.t("auditHlhtSystem.phoneNo"),
      key: "phoneNo",
      resizable: true,
      minWidth: 110
    },
    {
      title: i18n.t("oper.operatorId"),
      key: "operatorId",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("auditHlhtSystem.reason"),
      key: "reason",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("auditHlhtSystem.netType"),
      key: "netTypeDesc",
      resizable: true,
      minWidth: 100
    },
    {
      title: i18n.t("auditHlhtSystem.netDriection"),
      key: "netDriectionDesc",
      resizable: true,
      minWidth: 100
    },
    {
      title: i18n.t("auditHlhtSystem.netStatus"),
      key: "netStatusDesc",
      resizable: true,
      minWidth: 100
    },
    {
      title: i18n.t("auditHlhtSystem.beginTime"),
      key: "beginTime",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("auditHlhtSystem.endTime"),
      key: "endTime",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("operation"),
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];
  private tableList: object[] = [];
  private auditClick(item: objAny) {
    this.auditForm.netSystemPkId = item.netSystemPkId;
    this.auditForm.netStatus = 2;
    this.auditModal = true;
  }

  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  async getOptionList() {
    const ret = await getOptionList([
      optionKey.netStatusObj,
      optionKey.netDriectionObj
    ]); //请求字典
    this.netDriectionList = ret[optionKey.netDriectionObj]; // 客户名称
    this.netStatusList = ret[optionKey.netStatusObj]; // 客户名称
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getInterflowList(this.formInline);
    if (ret.status === this["$config"].apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async subSudit(): Promise<void> {
    const ret = await auditOprSystem(this.auditForm);
    if (ret.status === this["$config"].apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  mounted() {
    this.getOptionList();
  }
  activated() {
    const query = this.$route.query;
    if (query.netStatus) {
      this.formInline.globalPageIndex = 1;
      this.formInline.netStatus = query.netStatus;
      this.getTableList();
    } else {
      if (this.tableList.length == 0) {
        this.getTableList();
      }
    }
  }
}
